export const STOPPED = 'STOPPED';
export const PLAYING = 'PLAYING';
export const PAUSED = 'PAUSED';



// WEBPACK FOOTER //
// ./src/constants/states.js